import { classLists } from "conts/profileConst";
import { useState } from "react";

export const useDiscountPrivate = (formData, setFormData) => {
	const [discountPrivateErrors, setDiscountPrivateErrors] = useState({});

	const getAvailableDiscountPrivate = () => {
		const selectedValues = formData.discount_policy_for_private_class.map(
			(policy) => policy.policy,
		);
		return classLists.filter(
			(option) => !selectedValues.includes(option.value),
		);
	};

	const handleAddDiscountPrivatePolicy = () => {
		const defaultPolicy =
			getAvailableDiscountPrivate()[0].value || classLists[0].value;
		if (formData.discount_policy_for_private_class.length < classLists.length) {
			setFormData((prevState) => ({
				...prevState,
				discount_policy_for_private_class: [
					...prevState.discount_policy_for_private_class,
					{ policy: defaultPolicy || "", percentage: "" },
				],
			}));
		}
	};

	const handleRemoveDiscountPrivatePolicy = (policy) => {
		setFormData((prevState) => ({
			...prevState,
			discount_policy_for_private_class:
				prevState.discount_policy_for_private_class.filter(
					(currentPolicy) => currentPolicy.policy !== policy,
				),
		}));
	};

	const handleDiscountPrivatePolicyChange = (key, policy, newValue) => {
		const updatedPolicies = formData.discount_policy_for_private_class.map(
			(currentPolicy) =>
				currentPolicy.policy === policy
					? { ...currentPolicy, [key]: newValue }
					: currentPolicy,
		);

		validatePolicy(updatedPolicies);

		setFormData((prevState) => ({
			...prevState,
			discount_policy_for_private_class: updatedPolicies,
		}));
	};

	const validatePolicy = (policies) => {
		const newErrors = {};
		policies?.forEach(({ policy, percentage }) => {
			let errorMessage = "";
			if (percentage === "" || Number(percentage) === 0) {
				errorMessage = "Value must be filled";
			} else if (Number(percentage) < 5) {
				errorMessage = "Minimum is 5%";
			} else if (Number(percentage) > 90 && policy !== "First class") {
				errorMessage = "Must be up to 90%";
			}
			newErrors[policy] = errorMessage;
		});
		setDiscountPrivateErrors(newErrors);
		return newErrors;
	};

	const resetDiscountPrivateErrors = () => setDiscountPrivateErrors({});

	return {
		getAvailableDiscountPrivate,
		handleAddDiscountPrivatePolicy,
		handleRemoveDiscountPrivatePolicy,
		handleDiscountPrivatePolicyChange,
		discountPrivateErrors,
		validatePrivatePolicy: validatePolicy,
		resetDiscountPrivateErrors,
	};
};
